import React from "react";
import { Box, Typography, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
const Header = ({ equipmentTitle }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                width: "100%",
                backgroundColor: theme.palette.grey[100],
                borderRadius: "12px",
                boxShadow: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
            }}
        >
            {/* Logo */}
            <Box
                sx={{
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    maxHeight: 60,
                    pl: 2,
                }}
            >
                <img
                    src={require("../../assets/beko_logo.png")}
                    alt="Beko Logo"
                    style={{
                        maxHeight: "70px",
                        width: "auto",
                        objectFit: "contain",
                    }}
                />
            </Box>

            {/* Başlık */}
            <Stack
                spacing={0.5}
                alignItems="center"
                justifyContent="center"
                sx={{
                    flexGrow: 1,
                    textAlign: "center",
                }}
            >
                <Typography variant="h5" fontWeight={700} color="primary">
                    {t("EmergencyWorkOrder")}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                    {equipmentTitle}
                </Typography>
            </Stack>
        </Box>
    );
};

export default Header;
